import { Component } from '@angular/core';

@Component({
  selector: 'app-privacy-policy-en',
  templateUrl: './en.component.html',
  styleUrl: './en.component.scss'
})
export class PrivacyPolicyEnComponent {

}
